import { useWeb3React } from '@web3-react/core';
import { useState } from 'react';
import { toast } from 'react-toastify';

import { checkChainId } from '@/utils/web3Service';

import { onWithdrawBsc } from './helpers';

const useWithdraw = () => {
  const context = useWeb3React();
  const { chainId } = context;
  const provider = context.library?.provider;
  const account = context.account || '';
  const [loading, setLoading] = useState(false);

  const handleWithdraw = async (nonce: number, handleWhenWithdraw: (nonce: number) => void) => {
    try {
      checkChainId(chainId);
      setLoading(true);
      const res: any = await onWithdrawBsc({
        provider,
        account,
        nonce,
        callback: (hash) => console.log(hash),
      });
      if (res?.blockHash) {
        toast.success('Withdraw successfully!');
        handleWhenWithdraw(nonce);
      }
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      console.log('claim err: ', error);
      toast.error(error?.message || 'An error occurred');
    }
  };

  return { handleWithdraw, loading };
};

export default useWithdraw;
